import React, { useState, useEffect } from "react";
import { TextInput, Button, Dropdown } from "../indexComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

function AddTaskForm({ cancelBtnOnClick, onTaskAdded }) {
  const [clients, setClients] = useState([]);
  const [taskName, setTaskName] = useState("");

  // Ajoutez cette fonction pour récupérer les clients
  const fetchClients = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/clients`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch clients");
      }

      const data = await response.json();
      setClients(data);
    } catch (error) {
      console.error("Error fetching clients:", error);
    }
  };

  // Utilisez useEffect pour récupérer les clients lorsque le composant est monté
  useEffect(() => {
    fetchClients();
  }, []);

  const clientsOptions = [
    ...clients.map((client) => ({
      value: client.id,
      label: client.name + " " + client.company,
    })),
  ];

  const [steps, setSteps] = useState([""]);

  const handleStepChange = (index, event) => {
    const newSteps = [...steps];
    newSteps[index] = event.target.value;
    setSteps(newSteps);
  };

  const addStep = () => {
    setSteps([...steps, ""]);
  };

  const [selectedClient, setSelectedClient] = useState("");

  const handleClientChange = (selectedOption) => {
    console.log(selectedOption);
    setSelectedClient(selectedOption ? selectedOption.value : null);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const filteredSteps = steps.filter((step) => step.length > 0);

    console.log({
      name: taskName,
      clientId: selectedClient,
      steps: filteredSteps,
    });

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/tasks`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          name: taskName,
          clientId: selectedClient,
          steps: filteredSteps,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to add task");
      }

      setSelectedClient({ value: "", label: "" });
      setSteps([]);
      setTaskName("");
      onTaskAdded();
    } catch (error) {
      console.error("Error adding task:", error);
    }
  };

  return (
    <div id="AddTaskForm">
      <form>
        <TextInput
          labelText="Nom de la tache"
          name="tache_title"
          type="text"
          placeholder=""
          value={taskName}
          onChange={(e) => setTaskName(e.target.value)}
        />
        <label className="label">Client</label>
        <Dropdown
          options={clientsOptions}
          placeholder="Sélectioner un client"
          onChange={handleClientChange}
          value={selectedClient.value}
        />
        <div className="step-container">
          <h3 className="step-task-title">Étapes de la tâche :</h3>
          {steps.map((step, index) => (
            <div key={index}>
              <TextInput
                labelText={`Étape ${index + 1} :`}
                type="text"
                value={step}
                onChange={(e) => handleStepChange(index, e)}
              />
            </div>
          ))}
          <button type="button" className="add-step-btn" onClick={addStep}>
            <FontAwesomeIcon icon={faPlus} />
          </button>
        </div>

        <div className="btn-container">
          <Button
            className="cancel-add-task-btn"
            onClick={cancelBtnOnClick}
            text="Annuler"
          />
          <Button
            className="send-task-btn"
            type="submit"
            text="Confirmer"
            onClick={handleSubmit}
          />
        </div>
      </form>
    </div>
  );
}

export default AddTaskForm;
